import React from 'react'
import './subject.css'

class Option extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        event.preventDefault();
        this.props.onChange(this.props.id, event.target.value);
    }

    render() {
        let id = String.fromCharCode(this.props.id + 56) ;
        return (
            <div className="subject-entry">
                <div className="subject-entry-img" onClick={()=>this.props.deleteSelf(this.props.id)}><img className="subject-img-sub" src={require("../assert/sub_gray.png")}></img></div>
                <p className="subject-entry-word">{String.fromCharCode(this.props.id + 65)}</p>
                {/* 约束性组件   value={this...} react 至管理约束性组件的值 */}
                <textarea className="subject-entry-input subject-single-title" placeholder="选项内容" onChange={this.onChange} value={this.props.content}></textarea>
            </div>
        );
    }
}

export default Option;